import React from 'react';
import Flexbox from 'flexbox-react';
import PropTypes from 'prop-types';
import ProcessUtils from 'utils/ProcessUtils';
import ComponentUtils from 'utils/ComponentUtils';
import ProcessField from 'components/core/fields/ProcessField';
import RIEComboBox from 'components/core/editable/RIEComboBox';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import { css } from 'emotion';
import _ from 'lodash';

export default class CoordinateSystemField extends ProcessField {
    static propTypes = Object.assign({
        retrievedVariableName: PropTypes.string,
        coordinateSystemValue: PropTypes.string, //multi edit variable
        labelWidth: PropTypes.string,
        flexDirection: PropTypes.string
    }, ProcessField.propTypes);

    static defaultProps = Object.assign({
        flexDirection: 'row'
    }, ProcessField.defaultProps);

    onCoordinateSystemChanged = (fieldPath, value) => {
        let coordinateSystemName = value.value;
        if (coordinateSystemName === '') {
            coordinateSystemName = null;
        }

        const editor = ProcessUtils.getEditor(this.props.process);
        const conflicts = editor.getRetrievedVariableCoordinateSystemConflicts(coordinateSystemName, [this.props.retrievedVariableName]);

        if (_.isEmpty(conflicts)) {
            editor.addRetrievedVariablesToCoordinateSystem(coordinateSystemName, [this.props.retrievedVariableName]);
            editor.commit();
        } else {
            ComponentUtils.promptDimensionConflictResolution(this.props.process,
                coordinateSystemName,
                conflicts,
                (resolutions) => {
                    editor.addRetrievedVariablesToCoordinateSystem(coordinateSystemName, [this.props.retrievedVariableName], resolutions);
                    editor.commit();
                }
            );
        }

    };

    render() {
        const coordinateSystemOptions = ProcessUtils.getCoordinateSystemOptionsForVariable(this.props.process);
        let coordinateSystemValue = null;

        if (this.props.retrievedVariableName) {
            const retrievedVariable = this.props.process.variable_retrieval.retrieved_variables[this.props.retrievedVariableName];
            coordinateSystemValue = ProcessUtils.getCoordinateSystemSelectValue(retrievedVariable.coordinate_system, coordinateSystemOptions);
        } else {
            coordinateSystemValue = this.props.coordinateSystemValue;
        }

        return (
            <Flexbox flexDirection={this.props.flexDirection} justifyContent="flex-start" className={this.props.className}>
                {this.props.displayLabel &&
                <InfoBoxLabel
                    label="Coordinate System"
                    width={this.props.labelWidth}
                    labelWrap
                    className="noshrink"
                />
                }
                <Flexbox flexDirection="column" flexGrow={1}>
                    <RIEComboBox
                        value={coordinateSystemValue}
                        options={coordinateSystemOptions}
                        change={this.onCoordinateSystemChanged}
                        fieldPath={['variable_retrieval', 'retrieved_variables', this.props.retrievedVariableName, 'coordinate_system']}
                        isDisabled={!this.props.hasWritePermissions}
                        processId={this.props.process.name}
                        processErrors={this.props.processErrors}
                        formDisplay={this.props.forceFormDisplay}
                    />
                </Flexbox>
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/CoordinateSystemField.js